// import { UserRequestDto } from 'shared/api'; // Не используется в константах
import { UserRequestDto } from 'shared/api';
import { IListColumnMeta, EFieldType, IFormFieldsMeta } from 'shared/types/Page.interface';

// Статусы пользователей
export const USER_STATUS_CONFIG = {
  ACTIVE: { status: 'Активный', color: '#52c41a', label: 'Активный' },
  INACTIVE: { status: 'Неактивный', color: '#ff4d4f', label: 'Неактивный' },
  SUSPENDED: { status: 'Приостановлен', color: '#faad14', label: 'Приостановлен' },
  PENDING: { status: 'Ожидает', color: '#1890ff', label: 'Ожидает' },
} as const;

// Поля формы для создания/редактирования пользователя
export const USER_FORM_FIELDS: IFormFieldsMeta = [
  {
    name: 'lastname',
    label: 'Фамилия',
    type: EFieldType.input,
    required: true,
  },
  {
    name: 'firstname',
    label: 'Имя',
    type: EFieldType.input,
    required: true,
  },
  {
    name: 'middleName',
    label: 'Отчество',
    type: EFieldType.input,
  },
  {
    name: 'company',
    label: 'Компания',
    type: EFieldType.input,
    required: true,
  },
  {
    name: 'innCompany',
    label: 'ИНН компании',
    type: EFieldType.input,
  },
  {
    name: 'email',
    label: 'Email',
    type: EFieldType.input,
    required: true,
  },
  {
    name: 'status',
    label: 'Статус',
    type: EFieldType.select,
    required: true,
    options: [
      { value: 'ACTIVE', label: 'Активный' },
      { value: 'INACTIVE', label: 'Неактивный' },
      { value: 'SUSPENDED', label: 'Приостановлен' },
      { value: 'PENDING', label: 'Ожидает' },
    ],
  },
  {
    name: 'comment',
    label: 'Комментарий',
    type: EFieldType.textarea,
  },
] as const;

// Конфигурация колонок таблицы пользователей
export const USER_TABLE_COLUMNS: IListColumnMeta = [
  {
    title: 'ID',
    type: EFieldType.input,
    dataIndex: 'id',
    fixed: 'left',
    sortingPriority: 1,
  },
  {
    title: 'Фамилия',
    type: EFieldType.input,
    dataIndex: 'lastname',
    sortingPriority: 2,
  },
  {
    title: 'Имя',
    type: EFieldType.input,
    dataIndex: 'firstname',
    sortingPriority: 3,
  },
  {
    title: 'Отчество',
    type: EFieldType.input,
    dataIndex: 'middleName',
    sortingPriority: 4,
  },
  {
    title: 'Компания',
    type: EFieldType.input,
    dataIndex: 'company',
    sortingPriority: 5,
  },
  {
    title: 'Телефон',
    type: EFieldType.input,
    dataIndex: 'mobilePhone',
    sortingPriority: 6,
  },
  {
    title: 'Email',
    type: EFieldType.input,
    dataIndex: 'email',
    sortingPriority: 7,
  },
  {
    title: 'Статус',
    type: EFieldType.colored,
    dataIndex: 'status',
    colorMap: {
      Активный: 'green',
      Неактивный: 'red',
      Приостановлен: 'orange',
      Ожидает: 'blue',
    },
    sortingPriority: 7,
    selectOptions: {
      [UserRequestDto.status.ACTIVE]: 'Активный',
      [UserRequestDto.status.INACTIVE]: 'Неактивный',
      [UserRequestDto.status.SUSPENDED]: 'Приостановлен',
      [UserRequestDto.status.PENDING]: 'Ожидает',
    },
  },
];

// Типы для статуса пользователя
export type UserStatus = keyof typeof USER_STATUS_CONFIG;
